import React from 'react'
import { useDimensions } from 'src/ui/dimensions'

import { HeroBlock as Desc } from './desk'
import { HeroBlock as Mob } from './mob'
import { TSliderItem, TSliderText } from './types'

type Props = {
  sliderText: TSliderText
  images: TImages
}
export const HeroBlock: React.FC<Props> = ({ images, sliderText }) => {
  const { isTabletXS } = useDimensions()
  return isTabletXS ? (
    <Mob images={images} sliderText={sliderText} />
  ) : (
    <Desc images={images} sliderText={sliderText} />
  )
}
